import { useStaticQuery, graphql } from "gatsby";

const query = graphql`
  query CommunityQuery {
    craft {
      globalSet(handle: "communityBlock") {
        ... on Craft_communityBlock_GlobalSet {
          communityHeading
          communityDescription
          communityProjects {
            ... on Craft_communityProjects_project_BlockType {
              uid
              projectName
              projectUrl
              projectLogo {
                url
                width
                height
              }
            }
          }
        }
      }
    }
  }
`;

export default function useCommunityData() {
  const { craft } = useStaticQuery(query);
  const block = craft?.globalSet;

  return {
    heading: block?.communityHeading,
    content: block?.communityDescription,
    relatedProjects: (block?.communityProjects || [])
      .filter(project => project.projectLogo?.[0]?.url && project.projectUrl)
      .map(project => ({
        uid: project.uid,
        name: project.projectName,
        url: project.projectUrl,
        image: project.projectLogo[0],
      })),
  };
}
